// extracted by mini-css-extract-plugin
export default {"root":"goIRz7","paper":"k8Veqn","mobile":"MfMujT","fullscreen":"IaqFTS"};